import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navigation-button-group"
}
const _hoisted_2 = { class: "navigation-button-group__button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ozn_button = _resolveComponent("ozn-button")!

  return (_ctx.buttonList)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ozn_button, {
            class: _normalizeClass(["navigation-button-group__button", { active: _ctx.active == _ctx.buttonViews[0]?.name }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeView = _ctx.buttonViews[0]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonViews[0]?.name), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_ozn_button, {
            class: _normalizeClass(["navigation-button-group__button", { active: _ctx.active == _ctx.buttonViews[1]?.name }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeView = _ctx.buttonViews[1]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonViews[1]?.name), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]))
    : _createCommentVNode("", true)
}